var map = {
	"./icon_extension_doc.svg": 454,
	"./icon_extension_docx.svg": 455,
	"./icon_extension_etc.svg": 284,
	"./icon_extension_jpg.svg": 456,
	"./icon_extension_mp3.svg": 457,
	"./icon_extension_mp4.svg": 458,
	"./icon_extension_obj.svg": 459,
	"./icon_extension_pdf.svg": 460,
	"./icon_extension_ply.svg": 461,
	"./icon_extension_png.svg": 462,
	"./icon_extension_ppt.svg": 463,
	"./icon_extension_pptx.svg": 464,
	"./icon_extension_rar.svg": 465,
	"./icon_extension_stl.svg": 466,
	"./icon_extension_txt.svg": 467,
	"./icon_extension_xls.svg": 468,
	"./icon_extension_xlsx.svg": 469,
	"./icon_extension_zip.svg": 470
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 530;